// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".EcommerceConnectionItem-base__rF6VX{display:flex;flex-direction:column;gap:var(--size-1)}.EcommerceConnectionItem-errorBanner__vmckc{margin:0 var(--size-3) var(--size-2)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": "EcommerceConnectionItem-base__rF6VX",
	"errorBanner": "EcommerceConnectionItem-errorBanner__vmckc"
};
export default ___CSS_LOADER_EXPORT___;
